import { Stack } from "@mui/material";
import { FeaturedChallenges } from "Components/Loyalty/Shared/Challenges/Categories/FeaturedChallenges";
import { MonthlyChallenges } from "Components/Loyalty/Shared/Challenges/Categories/MonthlyChallenges";
import { WeeklyChallenges } from "Components/Loyalty/Shared/Challenges/Categories/WeeklyChallenges";

export const ChallengesSection = () => (
  <Stack gap={8}>
    <FeaturedChallenges />
    <WeeklyChallenges variant="compact" />
    <MonthlyChallenges variant="compact" />
  </Stack>
);
